import { useRef } from "react";
import ListingCard from "../components/ListingCard";
import { listingCategoryLabel, searchCategories } from "../data/listingCategories";

function SearchPage({
  embedded = false,
  activeCategory,
  browseError,
  handleFileChange,
  handleSearch,
  hasSearched,
  favoriteActionListingId,
  isLoadingBrowse,
  isLoadingShops,
  isSearching,
  listings,
  onOpenListing,
  onOpenShop,
  onClearSearch,
  onToggleFavorite,
  previewUrl,
  searchQuery,
  selectedFile,
  setActiveCategory,
  setSearchQuery,
  shopError,
  shops,
  status,
}) {
  const fileInputRef = useRef(null);

  function clearSearch() {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    onClearSearch();
  }

  return (
    <section className={embedded ? "marketplace-listings" : "main-panel"}>
      {!embedded && <>
      <div className="page-heading">
        <div>
          <span className="mini-label">AI-billedsøgning</span>
          <h1>Find lignende annoncer fra et billede</h1>
          <p>
            Upload et foto fra mobilen og fa relevante marketplace-resultater med
            matchscore, pris og tillidsindikatorer.
          </p>
        </div>
        <div className="summary-card">
          <strong>{listings.length}</strong>
          <span>{hasSearched ? "aktive forslag" : "aktive annoncer"}</span>
        </div>
      </div>

      <label className="listing-search-field">
        <span>Søg efter vare eller butik</span>
        <input
          type="search"
          value={searchQuery}
          onChange={(event) => setSearchQuery(event.target.value)}
          placeholder="For eksempel rød stol eller Emmas butik"
        />
      </label>

      </>}

      <details className="marketplace-image-search">
      <summary>Søg med et billede</summary>
      <div className="search-grid">
        <form className="upload-card" onSubmit={handleSearch}>
          <label className="image-drop">
            {previewUrl ? (
              <img src={previewUrl} alt="Valgt upload" />
            ) : (
              <div>
                <span>AI</span>
                <strong>Upload billede</strong>
                <p>Brug et foto af varen du leder efter.</p>
              </div>
            )}
            <input ref={fileInputRef} type="file" accept="image/*" onChange={handleFileChange} />
          </label>

          <div className="search-actions">
            <button className="primary-action" type="submit" disabled={isSearching}>
              {isSearching ? "Søger..." : "Find annoncer"}
            </button>
            {(selectedFile || hasSearched) && (
              <button className="secondary-action" onClick={clearSearch} type="button">
                Ryd billedsøgning
              </button>
            )}
          </div>
          <p className="status-line">{status}</p>
        </form>

      </div>

      </details>

      <div className={`search-results-layout ${!embedded && searchQuery.trim() ? "with-shops" : ""}`}>
      <section className="results-section">
        <div className="section-toolbar">
          <div>
            <span className="mini-label">{hasSearched ? "AI resultater" : "Annoncer"}</span>
            <h2>{hasSearched ? "Bedste matches" : "Gennemse annoncer"}</h2>
          </div>
          {!embedded && <div className="category-tabs">
            {searchCategories.map((category) => (
              <button
                className={activeCategory === category ? "active" : ""}
                key={category}
                onClick={() => setActiveCategory(category)}
                type="button"
              >
                {listingCategoryLabel(category)}
              </button>
            ))}
          </div>}
        </div>

        {isLoadingBrowse && !hasSearched ? (
          <div className="empty-results">Henter annoncer...</div>
        ) : browseError && !hasSearched ? (
          <div className="empty-results">
            <strong>Kunne ikke hente annoncer</strong>
            <p>{browseError}</p>
          </div>
        ) : listings.length === 0 ? (
          <div className="empty-results">
            <strong>{hasSearched ? "Ingen annoncer matchede billedet" : "Ingen annoncer fundet"}</strong>
            <p>
              {hasSearched
                ? "Prøv et tydeligere foto eller en anden vinkel af varen."
                : "Skift filter eller kom tilbage, når der er flere aktive annoncer."}
            </p>
          </div>
        ) : (
          <div className="listing-grid">
            {listings.map((listing) => (
              <ListingCard
                favoriteActionListingId={favoriteActionListingId}
                key={listing.id}
                listing={listing}
                onOpen={onOpenListing}
                onToggleFavorite={onToggleFavorite}
              />
            ))}
          </div>
        )}
      </section>
      {!embedded && searchQuery.trim() && (
        <aside className="shop-search-results">
          <div><span className="mini-label">Butikker</span><h2>Butikker</h2></div>
          {isLoadingShops ? <div className="compact-shop-status">Søger...</div> : shopError ? <div className="compact-shop-status error">{shopError}</div> : shops.length ? (
            <div className="shop-result-grid">
              {shops.map((shop) => (
                <button className="shop-result-card" key={shop.id} onClick={() => onOpenShop(shop)} style={{ "--shop-color": shop.shop_color }} type="button">
                  {shop.shop_logo_url ? <img src={shop.shop_logo_url} alt={`${shop.shop_name} logo`} /> : <div className="shop-logo-placeholder">Butik</div>}
                  <div><strong>{shop.shop_name}</strong><span>{shop.location || "Lokation ikke angivet"}</span><small>{shop.active_listing_count} aktive varer · {shop.rating_count ? `${shop.rating_average.toFixed(1)} rating` : "Ingen rating"}</small></div>
                </button>
              ))}
            </div>
          ) : <div className="compact-shop-status">Ingen matchende butikker.</div>}
        </aside>
      )}
      </div>
    </section>
  );
}

export default SearchPage;
